import { ButtonGroup, FormControlSizes, ToggleButton } from '@talos/kyoko';
import { SIGNALS_TIME_RANGES, type SignalsTimeRange } from './tokens';

interface SignalsTimeRangeControlProps {
  /** Active preset. Pass `undefined` when the user has set a custom date range (no button highlighted). */
  value: SignalsTimeRange | undefined;
  onChange: (range: SignalsTimeRange) => void;
  disabled?: boolean;
}

/** Time range toggle shared by every Signals module — 1M / 3M / 6M / 12M as a `ButtonGroup`. */
export function SignalsTimeRangeControl({ value, onChange, disabled }: SignalsTimeRangeControlProps) {
  return (
    <ButtonGroup size={FormControlSizes.Small} data-testid="signals-time-range-control">
      {SIGNALS_TIME_RANGES.map(range => (
        <ToggleButton
          key={range}
          selected={value === range}
          onClick={() => onChange(range)}
          disabled={disabled}
          data-testid={`signals-time-range-${range}`}
        >
          {range}
        </ToggleButton>
      ))}
    </ButtonGroup>
  );
}
